import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { RouterModule } from '@angular/router';
import { appRoutes } from './app.routes';
import { AdminSidebarComponent } from './layouts/admin-sidebar/admin-sidebar.component';
import { AdminNavigationComponent } from './layouts/admin-navigation/admin-navigation.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { TokenInterceptService } from './interceptors/token-intercept.service';

@NgModule({

    declarations: [AppComponent, AdminLayoutComponent, AdminSidebarComponent, AdminNavigationComponent, PublicLayoutComponent],
    imports: [BrowserModule, RouterModule.forRoot(appRoutes), BrowserAnimationsModule, ToastrModule.forRoot(), HttpClientModule],
    providers: [
        {

            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptService,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
